// 本地缓存用户信息的
export const userKey = 'APP_USER_KEY';

export const userToken = 'APP_USER_TOKEN';

export const REGISTER_KEY = 'REGISTER_KEY';
/**
 * 首页刷新获得的推荐用户
 */
export const Index_Fresh_Info = 'Index_Fresh_Info';

export const Current_Order_KEY = 'Current_Order';
